import { Routes } from '@angular/router';
import { roleGuard } from 'src/lib/guards/admin-role.guard';
import { permissionGuard } from 'src/lib/guards/permission.guard';
import { HBBS_CONFIG } from './base/homepage-builder-booking-settings-config';

export const homepageBuilderBookingSettingsRoutes: Routes = [
  {
    path: HBBS_CONFIG.routePath!,
    data: { title: HBBS_CONFIG.title! },
    canActivate: [
      roleGuard('ADMIN_MASTER'),
      permissionGuard('HOME_SCREEN$READ'),
    ],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/hbbs-list-page/hbbs-list-page.component'
          ).then((m) => m.HbbsListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/hbbs-detail-page/hbbs-detail-page.component'
              ).then((m) => m.HbbsDetailPageComponent),
            data: { title: 'Homepage Builder Booking Settings Detail' },
          },
        ],
      },
    ],
  },
];
